import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
  const token = localStorage?.getItem("token");
  return token === null ? <Navigate replace to="/login" /> : <Outlet />;
};

export default PrivateRoutes;
